export default __webpack_public_path__ + "static/media/avatar_indian_boy9.d595f450.mp3";